// My Stats' Utilization (2026-10-27, Patrick's ask): the share of the time Schedule Hub
// scheduled the agent in CXHub that went on handling contacts. Same definition as the
// Scorecards column (handle time / scheduled hours): handle time across every account
// including Support Email, over the in-queue working minutes of completed days. A period
// with no scheduled CXHub time reads null ("no data"), never 0%; scheduled with nothing
// handled is a real 0%. Several periods pool as sum over sum, never an average of
// percentages.

// handleMs and scheduledMinutes are one period's totals.
export function utilizationFor(handleMs, scheduledMinutes) {
  if (typeof scheduledMinutes !== 'number' || !(scheduledMinutes > 0)) return null
  return (handleMs ?? 0) / (scheduledMinutes * 60000)
}

// One period of a My Stats response (weekly or monthly).
export function periodUtilization(data, period) {
  return utilizationFor(data.completedHandleMs?.[period], data.cxhubScheduled?.sums?.[period])
}

// The Total row: handle time over scheduled time across the periods shown, counting only the
// periods that have scheduled time (a period with none has nothing to compare against).
export function totalUtilization(data, periods) {
  let handle = 0
  let scheduled = 0
  for (const p of periods) {
    const s = data.cxhubScheduled?.sums?.[p]
    if (typeof s === 'number' && s > 0) {
      scheduled += s
      handle += data.completedHandleMs?.[p] ?? 0
    }
  }
  return utilizationFor(handle, scheduled)
}
